import { render, staticRenderFns } from "./PositionChoice.vue?vue&type=template&id=5058cc7c&scoped=true&"
import script from "./PositionChoice.vue?vue&type=script&lang=js&"
export * from "./PositionChoice.vue?vue&type=script&lang=js&"
import style0 from "./PositionChoice.vue?vue&type=style&index=0&id=5058cc7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5058cc7c",
  null
  
)

export default component.exports